const styles: any = {
    control: (baseStyles: any, state: any) => {
        let ret = baseStyles;
        ret.borderWidth = '4px';
        ret.fontSize = '1rem';
        ret.fontWeight = '600';
        ret.borderColor = 'transparent';
        ret.cursor = 'text';
        ret.padding = '4px';

        if (state.isFocused) {
            ret = { ...ret, ...{
                backgroundColor: 'white !important',
                borderColor: '#8c18f1',
                borderWidth: '4px',
                boxShadow: '0 0 0 2px rgb(115 30 218 / 50%) inset',
                color: '#373a41 !important'
            }}
        }

        return ret;
    },
    placeholder: (baseStyles: any, state: any) => {
        baseStyles.color = '#8c18f1';
        baseStyles.fontWeight = 700;

        return baseStyles;
    },
    menu: (baseStyles: any, state: any) => {
        let ret = baseStyles;
        ret.fontSize = '1rem';
        ret.fontWeight = '700';
        ret.borderColor = 'transparent';
        ret.cursor = 'text';
        ret.padding = '16px 24px';
        ret.color = 'black';
        return baseStyles;
    },
    option: (baseStyles: any, state: any) => {
        delete baseStyles[':active'];
        delete baseStyles.backgroundColor;
        baseStyles.borderBottom = '1px solid rgba(0,0,0,.1)';
        baseStyles.borderBottomWidth = '1px';
        baseStyles.borderBottomStyle = 'solid';
        baseStyles.borderBottomColor = 'rgba(0, 0, 0, 0.1)';
        baseStyles.padding = '4px 0';
        baseStyles.cursor = 'pointer';

        if (state.isFocused) {
            baseStyles.color = '#8c18f1';
        }
        return baseStyles;
    }
}

export default styles;